import React from 'react';
import { TargetArrowIcon } from '../your-quick-richuels/icons';
import { ArrowIcon } from './icons';
import styles from './ForecastProgressFooter.module.css';

export const FORECAST_PROGRESS_FOOTER_CTA_LABEL = 'Explore More Richuels';

const DEFAULT_TITLE = 'Turn your plan into progress.';
const DEFAULT_SUBTITLE =
  'Get personalized guidance, track your goals, and make confident financial decisions with Richuel.';

export default function ForecastProgressFooter({
  onStartMove,
  onClose,
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
  ctaLabel = FORECAST_PROGRESS_FOOTER_CTA_LABEL,
  ariaLabel,
  hideCta = false,
  className,
  icon,
  iconWrapClassName,
}) {
  const showCta = !hideCta && typeof onStartMove === 'function';
  const showClose = typeof onClose === 'function';

  return (
    <section
      className={[styles.forecastProgressFooter, className].filter(Boolean).join(' ')}
      aria-label={ariaLabel || title}
    >
      <div className={styles.forecastProgressFooterCopy}>
        <span
          className={[styles.forecastProgressFooterIconWrap, iconWrapClassName].filter(Boolean).join(' ')}
          aria-hidden="true"
        >
          {icon || <TargetArrowIcon className={styles.forecastProgressFooterIcon} />}
        </span>
        <div className={styles.forecastProgressFooterText}>
          <h2 className={styles.forecastProgressFooterTitle}>{title}</h2>
          <p className={styles.forecastProgressFooterSubtitle}>{subtitle}</p>
        </div>
      </div>
      {showClose || showCta ? (
        <div className={styles.forecastProgressFooterActions}>
          {showClose ? (
            <button type="button" className={styles.forecastProgressFooterClose} onClick={onClose}>
              Close
            </button>
          ) : null}
          {showCta ? (
            <button type="button" className={styles.forecastProgressFooterCta} onClick={onStartMove}>
              {ctaLabel}
              <ArrowIcon className={styles.forecastProgressFooterCtaArrow} />
            </button>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
